import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../../context/UserContext";
import { Link } from "react-router-dom";

import CustomFieldText from "../../form/CustomFieldText";
import GenericModal from "../../_generic_modal";

import * as Helper from "../../form/form_inscription_helper";
import ChanceBlock from "./_chanceBlock";

const Chemin = () => {

  const { i18n,t } = useTranslation();


  //Context user
  const { user, logout } = useContext(UserContext)

  //Form
  const { register: registerAddCode, handleSubmit: handleSubmitAddCode, formState: { errors: errorsAddCode }, reset: resetAddCode } = useForm()

  //Ref
  const submitAddCodeRef = useRef(null)

  //State
  const [globalError, setGlobalError] = useState("")
  const [showAddModal, setShowAddModal] = useState(false)
  const [showCardModal, setShowCardModal] = useState(false)
  const [showErrorCardModal, setShowErrorCardModal] = useState(false)
  const [showFreeCardModal, setShowFreeCardModal] = useState(false)
  const [showBonusAnimation, setShowBonusAnimation] = useState(false)
  const [bonusValue, setBonusValue] = useState(1)

  const [cardType, setCardType] = useState("")
  const [cardCode, setCardCode] = useState("")

  //Modal handle
  const handleCloseAddModal = () => {
    setShowAddModal(false)

    setTimeout(() => {
      resetAddCode()
    }, 500)

  }

  //Const
  const card_details = {
    "CARTE1": [t("chemin_carte_1_details"), t("chemin_carte_1_name")],
    "CARTE2": [t("chemin_carte_2_details"), t("chemin_carte_2_name")],
    "CARTE3": [t("chemin_carte_3_details"), t("chemin_carte_3_name")],
    "CARTE4": [t("chemin_carte_4_details"), t("chemin_carte_4_name")],
    "CARTE5": [t("chemin_carte_5_details"), t("chemin_carte_5_name")],
    "CARTE6": [t("chemin_carte_6_details"), t("chemin_carte_6_name")],
    "CARTE7": [t("chemin_carte_7_details"), t("chemin_carte_7_name")],
    "CARTE8": [t("chemin_carte_8_details"), t("chemin_carte_8_name")]
  }
  const date_ope = {
    "CARTE2": ["2025-02-07", "2025-02-17"],
    "CARTE3": ["2025-03-14", "2025-03-24"],
    "CARTE4": ["2025-04-14", "2025-04-23"],
    "CARTE5": ["2025-06-16", "2025-06-23"],
    "CARTE6": ["2025-10-24", "2025-11-03"],
    "CARTE7": ["2025-11-21", "2025-12-01"],
    "CARTE8": ["2025-12-26", "2026-01-03"],
  }

  //submit card code
  const submitAddCode = (data) => {

    submitAddCodeRef.current.setAttribute("disabled", "disabled");
    setCardCode(data.code_unique)

    let formData = new FormData();
    formData.append('form', JSON.stringify(data))
    formData.append("action", "add_card")
    formData.append("lang", i18n.language)

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {

        if (json.success) {
          handleCloseAddModal()
          setCardType(json.data.type)

          //check user card count to display bonus animation
          const cardCount = Object.entries(userData.cartes).filter(value => value[1] === true).length + 1
          let bonus = cardCount === 3 ? 1 : cardCount === 6 ? 2 : cardCount === 8 ? 3 : 0

          if (bonus !== 0) {
            setBonusValue(bonus)
            setShowBonusAnimation(true)

            setTimeout(() => {
              setShowBonusAnimation(false)
              setTimeout(() => {
                setShowCardModal(true)
              }, 500)
            }, 4000)
          } else
            setShowCardModal(true)


        } else {
          setCardCode("")
          switch (json.message) {

            case "#expired":
              setGlobalError(t("chemin_error_expired"))
              break;

            case "#unknown":
              setGlobalError(t("chemin_error_unknown"))
              break;

            case "#already_used":
              setGlobalError(t("chemin_error_already_used"))
              break;

            case "#outdated":
              setGlobalError(t("chemin_error_outdated"))
              break;

            case "#already":
              handleCloseAddModal()
              setCardType(json.data.type)
              setShowErrorCardModal(true)
              break;
            default:
              alert(json.message);
          }

          submitAddCodeRef.current.removeAttribute("disabled");
        }
      });
  }

  const ScrollToCard = (defaultCard) => {
    const today = new Date()
    let cartetoScroll = defaultCard

    for (const [carte, [start, end]] of Object.entries(date_ope)) {
      const startDate = new Date(start)
      const endDate = new Date(end)

      if (today >= startDate && today <= endDate) {
        cartetoScroll = carte
        const carteNumber = parseInt(cartetoScroll.replace("CARTE", ""), 10) + 1;
        document.getElementById("carte_CARTE" + carteNumber).classList.add("next_card")
      }
    }

    document.getElementById("carte_" + cartetoScroll).scrollIntoView({ behavior: "smooth" })
  };


  //load user data
  const [userData, setUserData] = useState([])
  useEffect(() => {
    let formData = new FormData();
    formData.append("action", "get_user");

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {

          //chemin couleur gold jusqu'a la dernière cartes débloquées
          json.data.way = {
            'CARTE1': true,
            'CARTE2': true,
            'CARTE3': true,
            'CARTE4': true,
            'CARTE5': true,
            'CARTE6': true,
            'CARTE7': true,
            'CARTE8': true
          }

          Object.entries(json.data.cartes).reverse().some(([key, card]) => {
            json.data.way[key] = false

            if (card)
              json.data.lastCard = key

            return card
          })

          //badge bonus
          let count = 0
          const TotalCount = Object.entries(json.data.cartes).filter(value => value[1] === true).length

          json.data.bonus = {
            'CARTE1': "",
            'CARTE2': "",
            'CARTE3': "",
            'CARTE4': "",
            'CARTE5': "",
            'CARTE6': "",
            'CARTE7': "",
            'CARTE8': ""
          }

          Object.entries(json.data.cartes).some(([key, card]) => {

            if (card)
              count++

            if ((count === 3 || count === 6 || count === 8))
              json.data.bonus[key] = count !== 8 ? "bonus1" : "bonus2"

            return count >= TotalCount
          })
          setUserData(json.data)

          setTimeout(() => {
            //scroll to last card or current operation
            ScrollToCard(json.data.lastCard)
          }, 300)
        }
      });

    //show free card modal if needed
    if (localStorage.getItem("showModalFreeCard") !== null) {
      setShowFreeCardModal(true)
      localStorage.removeItem("showModalFreeCard")
    }

  }, []);


  return (
    <>
      <div className={"strate"} id={"accountStrate1"}>

        <button type={"button"} className={"cta gold"} id={"add_card_fixed"} onClick={() => setShowAddModal(true)}>+</button>

        <div id={"cartes_wrapper"}>

          <div id={"prize"} className={`${userData.cartes?.CARTE8 ? 'unlock' :''}`}>
            <div dangerouslySetInnerHTML={{ __html: t("chemin_grand_tirage") }} />
            <div dangerouslySetInnerHTML={{ __html: t("chemin_gain_montant") }} />
            <div dangerouslySetInnerHTML={{ __html: t("chemin_gain_description") }} />
            <div className={'lock'} />
            <div className={"halo"} />
          </div>

          {userData.cartes && Object.entries(userData.cartes)
            .reverse()
            .map(([key, card]) => {

              return (
                <div className={`carte${card ? " unlocked" : ""} ${userData.way[key] ? ' way_unlocked' : ''}`} id={"carte_" + key} onClick={() => setShowAddModal(true)}>
                  <div className={"separator"} />
                  <div className={"halo"} />
                  <div className={"picture"}>
                    {userData.bonus[key] !== "" && <div className={`bonus ${userData.bonus[key]}`} />}
                  </div>


                  <div className={"content"}>
                    <div className={"lock"} />
                    {key !== "CARTE1" && key !== "CARTE5" && <div className={"date"}>{card_details[key][0]}</div>}
                    {key === "CARTE5" && <div className={"date"}>{t("chemin_cet_ete")}</div>}
                    <div className={"text"}>
                      {card_details[key][1] === "" &&
                        <>
                          <div>{t("chemin_prochain")}</div>
                          <div>{t("chemin_rendez_vous")}</div>
                        </>
                      }
                      {card_details[key][1] !== "" &&
                        <>
                          <div>{t("chemin_vous_avez")}</div>
                          <div>{t("chemin_rendez_vous")}</div>
                          <div>{key !== "CARTE7" ? t("chemin_avec") : t("chemin_en")}</div>
                          <div dangerouslySetInnerHTML={{__html : card_details[key][1]}}></div>
                        </>
                      }
                      {card &&
                        <>
                          <div>{t("chemin_plus_1_chance")}</div>
                          <div>{t("chemin_pour")}</div>
                          <div>{t("chemin_tirage_au_sort")}</div>
                        </>
                      }
                    </div>
                  </div>
                </div>
              )
            })}

          {userData.cartes && <ChanceBlock user={userData} />}
        </div>

        <div className={"cta_wrapper"}>
          <button className={"cta gold"} onClick={() => setShowAddModal(true)} dangerouslySetInnerHTML={{ __html: t("chemin_ajouter_une_carte") }} />
        </div>
        <div className={"traduction"}>
          <sup>*</sup>French Riviera = Côte d'Azur.
        </div>
      </div>

      <div id={"bonus"} className={`${showBonusAnimation ? "show" : ""} ${bonusValue !== 0 ? 'bonus' + bonusValue : ''}`} />

      <GenericModal show={showAddModal} id={"add_code_modal"} handleClose={handleCloseAddModal}>
        <p dangerouslySetInnerHTML={{ __html: t("chemin_collecte_cartes") }} />
        <p dangerouslySetInnerHTML={{ __html: t("chemin_chance_supplementaire") }} />
        <div className={"gold_separator"} />
        <div className={"title"} dangerouslySetInnerHTML={{ __html: t("chemin_saisissez_code_unique") }} />
        <form onSubmit={handleSubmitAddCode(submitAddCode)}>
          <CustomFieldText name={"code_unique"} id={"code_unique"} placeholder={t("chemin_code_unique")} register={registerAddCode("code_unique", {
            required: Helper.EmptyErrorMessages.code_unique
          })} error={errorsAddCode.code_unique && errorsAddCode.code_unique.message} />
          <div className={"form_mention"} dangerouslySetInnerHTML={{ __html: t("chemin_code_unique_emplacement") }} />
          <div className={"error"} dangerouslySetInnerHTML={{ __html: globalError }} />
          <div className={"cta_wrapper"}>
            <input type={"submit"} id={"submit_cta"} className={"cta gold"} ref={submitAddCodeRef} value={t("chemin_ajouter_une_carte")} />
          </div>
        </form>
      </GenericModal>

      <GenericModal show={showCardModal} id={"card_detail_modal"} showHeader={false}>
        <div id={"card"} className={cardType} />
        <div className={"title"} dangerouslySetInnerHTML={{ __html: t("chemin_nouvelle_carte_obtenue") }} />
        <div className={"gold_separator"} />
        <p dangerouslySetInnerHTML={{ __html: t("chemin_attente_tirage") }} />
        <div className={"cta_wrapper"}>
          <Link to={`/instant-gagnant/${cardCode}`} className={"cta gold"} >{t("chemin_decouvrir")}</Link>
        </div>
      </GenericModal>

      <GenericModal show={showErrorCardModal} id={"card_error_modal"} handleClose={() => setShowErrorCardModal(false)}>
        <div id={"card"} className={cardType} />
        <p dangerouslySetInnerHTML={{ __html: t("chemin_carte_deja_ajoutee") }} />
        <div className={"cta_wrapper"}>
          <button className={"cta gold"} onClick={() => {
            setShowErrorCardModal(false)
            setShowAddModal(true)
          }} dangerouslySetInnerHTML={{ __html: t("chemin_ajouter_autre_carte") }} />
        </div>
      </GenericModal>

      <GenericModal show={showFreeCardModal} id={"carte_offerte_modal"} handleClose={() => setShowFreeCardModal(false)}>
      </GenericModal>

    </>
  )
}

export default Chemin
